import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import Corbado from '@corbado/web-js';
import { UserService, UserState } from '../../services/user-service/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-logout',
  imports: [],
  templateUrl: './logout.component.html',
  styleUrl: './logout.component.scss'
})
export class LogoutComponent implements OnInit {
 
  constructor(private router: Router, private userService: UserService) {
  }

  async ngOnInit() {
    setTimeout(() => {
      this.logout();
    }, 1000);
  }

  async logout() {
    
      await Corbado.load({
        projectId: environment.CORBADO_PROJECT_ID,
        darkMode: 'off',
        theme: "corbado-styles"
    });
  
    Corbado.logout();
    this.userService.resetUserState();
    this.router.navigate(['/'])
  }
}
